import { extendComponentDefinition } from '@seahax/elemental';

const el = document.querySelector('link[data-stylesheet-reset]') as HTMLLinkElement;
const sheet = [...document.styleSheets].find((sheet) => sheet.ownerNode === el)!;
const sheetCopy = new CSSStyleSheet();

for (const rule of sheet.cssRules) {
  sheetCopy.insertRule(rule.cssText);
}

export const define = extendComponentDefinition({
  styles: [sheetCopy],
});
